import { Ruleset } from 'entities/campaign';
import { Client, Options } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { mapMpsMessageRulesetResponseToEntity } from '../../adapters';
import { MpsMessageRulesetResponse } from '../../types';
import { toStorageFormat, ExpandedSite, rulesets, fromStorageFormat } from '../expandedQueries';
import { Service } from '../services';

function mapFromResponse(x: MpsMessageRulesetResponse) {
  const mapped = mapMpsMessageRulesetResponseToEntity(x);
  mapped.entity = fromStorageFormat(mapped.entity);
  return mapped;
}

export const clientOptions: Options<Ruleset, Ruleset, MpsMessageRulesetResponse, ExpandedSite> = {
  mapToRequest: x => toStorageFormat(x),
  mapFromResponse,
  mapFromListResponse: rulesets,
};

export const client = new Client(clientOptions);

export const { Actions, Selectors, Sagas } = createService<Ruleset, Service.Rulesets>({
  service: Service.Rulesets,
  client,
  endpointCreator: '/mps/sites/${siteId}/campaigns/${campaignId}/message-rulesets', // eslint-disable-line
  stateConverter: (state: State) => state.campaigns.rulesets,
  persistUpdates: true,
  endpointOverrides: {
    getCollection: '/mps/sites/${siteId}/expanded_message_rulesets', // eslint-disable-line
  },
});
